import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Highlights"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("h1", { class: "fs-1" }, "Hello Trezo"),
              _createElementVNode("h2", { class: "fs-2" }, "Hello Trezo"),
              _createElementVNode("h3", { class: "fs-3" }, "Hello Trezo"),
              _createElementVNode("h4", { class: "fs-4" }, "Hello Trezo"),
              _createElementVNode("h5", { class: "fs-5" }, "Hello Trezo"),
              _createElementVNode("h6", { class: "fs-6" }, "Hello Trezo"),
              _createElementVNode("p", { class: "text-gray-light" }, [
                _createTextVNode(" Lorem ipsum "),
                _createElementVNode("span", { class: "text-success" }, "dolor"),
                _createTextVNode(", sit amet consectetur adipisicing elit. Aliquam aliquid vel porro natus? Est culpa aliquid, cumque "),
                _createElementVNode("span", { class: "text-dark" }, "eligendi"),
                _createTextVNode(" inventore laborum, sit "),
                _createElementVNode("span", { class: "text-danger" }, "incidunt"),
                _createTextVNode(" accusamus nesciunt vitae recusandae quos eaque saepe? Laudantium. ")
              ]),
              _createElementVNode("p", { class: "text-gray-light" }, [
                _createTextVNode(" Lorem ipsum "),
                _createElementVNode("span", { class: "mark" }, "dolor"),
                _createTextVNode(", sit amet consectetur adipisicing elit. Aliquam aliquid vel porro natus? Est culpa aliquid, cumque "),
                _createElementVNode("span", { class: "mark" }, "eligendi"),
                _createTextVNode(" inventore laborum, sit "),
                _createElementVNode("span", { class: "mark" }, "incidunt"),
                _createTextVNode(" accusamus nesciunt vitae "),
                _createElementVNode("em", { class: "text-dark" }, "recusandae"),
                _createTextVNode(" quos eaque saepe? Laudantium. ")
              ]),
              _createElementVNode("p", { class: "text-gray-light" }, [
                _createTextVNode(" Lorem "),
                _createElementVNode("span", { class: "d-inline-block text-primary bg-primary px-2 rounded-2 bg-opacity-10" }, "Laudantium"),
                _createTextVNode(" ipsum "),
                _createElementVNode("span", { class: "text-success" }, "dolor"),
                _createTextVNode(", sit amet consectetur adipisicing elit. "),
                _createElementVNode("span", { class: "d-inline-block text-white bg-danger px-2 rounded-2" }, "Laudantium"),
                _createTextVNode(" Aliquam aliquid vel porro natus? Est culpa aliquid, cumque "),
                _createElementVNode("span", { class: "text-dark" }, "eligendi"),
                _createTextVNode(" inventore laborum, sit "),
                _createElementVNode("span", { class: "text-danger" }, "incidunt"),
                _createTextVNode(" accusamus nesciunt vitae recusandae quos eaque saepe? "),
                _createElementVNode("span", { class: "d-inline-block text-white bg-primary px-2 rounded-2" }, "Laudantium"),
                _createTextVNode(". ")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, "\n<h1>Hello Trezo</h1>\n<h2>Hello Trezo</h2>\n<h3>Hello Trezo</h3>\n<h4>Hello Trezo</h4>\n<h5>Hello Trezo</h5>\n<h6>Hello Trezo</h6>\n<p class=\"text-gray-light\">Lorem ipsum <span class=\"text-success\">dolor</span>, sit amet consectetur adipisicing elit. Aliquam aliquid vel porro natus? Est culpa aliquid, cumque <span class=\"text-dark\">eligendi</span> inventore laborum, sit <span class=\"text-danger\">incidunt</span> accusamus nesciunt vitae recusandae quos eaque saepe? Laudantium.</p>\n<p class=\"text-gray-light\">Lorem ipsum <span class=\"mark\">dolor</span>, sit amet consectetur adipisicing elit. Aliquam aliquid vel porro natus? Est culpa aliquid, cumque <span class=\"mark\">eligendi</span> inventore laborum, sit <span class=\"mark\">incidunt</span> accusamus nesciunt vitae <em class=\"text-dark\">recusandae</em> quos eaque saepe? Laudantium.</p>\n<p class=\"text-gray-light\">Lorem <span class=\"d-inline-block text-primary bg-primary px-2 rounded-2 bg-opacity-10\">Laudantium</span> ipsum <span class=\"text-success\">dolor</span>, sit amet consectetur adipisicing elit. <span class=\"d-inline-block text-white bg-danger px-2 rounded-2\">Laudantium</span> Aliquam aliquid vel porro natus? Est culpa aliquid, cumque <span class=\"text-dark\">eligendi</span> inventore laborum, sit <span class=\"text-danger\">incidunt</span> accusamus nesciunt vitae recusandae quos eaque saepe? <span class=\"d-inline-block text-white bg-primary px-2 rounded-2\">Laudantium</span>.</p>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}